import * as Sentry from "@sentry/react";
import { getRuntimeConfig } from "@evolys/api-client";

let initialized = false;

export function initializeFrontendObservability() {
  if (initialized) return;
  initialized = true;

  const dsn = getRuntimeConfig("SENTRY_DSN", undefined, "");
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: getRuntimeConfig(
      "SENTRY_ENVIRONMENT",
      undefined,
      "production",
    ),
    release:
      getRuntimeConfig("SENTRY_RELEASE", undefined, "") || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    sendDefaultPii: false,
    tracesSampleRate: parseSampleRate(
      getRuntimeConfig(
        "SENTRY_TRACES_SAMPLE_RATE",
        undefined,
        "0.05",
      ),
    ),
    beforeSend(event) {
      // This is a clinical application. Retain stack/type diagnostics while
      // excluding identities, request bodies, cookies, query strings, and
      // breadcrumb messages that may contain patient-entered content.
      event.user = undefined;
      event.message = event.message
        ? "Frontend application error"
        : event.message;
      event.exception?.values?.forEach((value) => {
        value.value = value.type ?? "Frontend application error";
      });
      if (event.request) {
        event.request.cookies = undefined;
        event.request.data = undefined;
        event.request.query_string = undefined;
        event.request.headers = undefined;
      }
      event.breadcrumbs = event.breadcrumbs?.map((breadcrumb) => ({
        category: breadcrumb.category,
        level: breadcrumb.level,
        timestamp: breadcrumb.timestamp,
        type: breadcrumb.type,
      }));
      return event;
    },
  });
}

export function captureFrontendException(
  error: unknown,
  context?: Record<string, string>,
) {
  if (!dsnConfigured()) return;
  Sentry.captureException(error, {
    contexts: context
      ? {
          react: context,
        }
      : undefined,
  });
}

function dsnConfigured() {
  return Boolean(getRuntimeConfig("SENTRY_DSN", undefined, ""));
}

function parseSampleRate(value: string) {
  const parsed = Number(value);
  return Number.isFinite(parsed)
    ? Math.min(1, Math.max(0, parsed))
    : 0.05;
}
